import script from "./MemberManagementPage2.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberManagementPage2.vue?vue&type=script&setup=true&lang=js"

import "./MemberManagementPage2.vue?vue&type=style&index=0&id=0460af70&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0460af70"]])

export default __exports__